import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { get } from "../../Common/api";
import config from "../../config";

export function Callback() {
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const code = queryParams.get("code");
  const state = queryParams.get("state");
  const error = queryParams.get("error");
  const error_description = queryParams.get("error_description");
  const returnUrl = decodeURIComponent(document.cookie
    .split("; ")
    .find((row) => row.startsWith("returnUrl="))
    ?.split("=")[1]);

  useEffect(async () => {
    let mounted = true;
    try {
      let url = `/Account/Identity?code=${code}&state=${state}`;
      if (error) {
        url += `error=${error}&error_description=${error_description}`
      }
      const result = await get(url);
      if (mounted && result && result.identity && result.identity.authenticated) {
        let selectClientUrl = `${config.loginRoot}/select-client`;
        selectClientUrl += (returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : '');
        history.replace(selectClientUrl);
      }
    } catch (error) {
      history.replace(`${config.loginRoot}?error=unknown`);
    }
    return () => mounted = false;
  },  [])
  return (
    <React.Fragment>
      <h4 className="form-title">Please wait while we log you in</h4>
    </React.Fragment>
  );
}